import { useForm } from 'react-hook-form';
import emailjs from 'emailjs-com';
import { useNavigate } from 'react-router-dom';

export function PageContact() {
    return (
        <section className='contact bg-section-secondary'>
            <div className='contact__container container py-4 py-md-5'>
                <div className='contact__box'>
                    <FormContact />
                </div>
            </div>
        </section>
    );
}

export function FormContact() {
    const { register, formState: { errors }, handleSubmit } = useForm();
    const navigate = useNavigate();

    const onSubmit = (data) => {
        var infoContact = `Nombre: ${data.nombre} || Apellido: ${data.apellido} || Telefono: ${data.telefono} || Email: ${data.email} || Cómo ayudarte: ${data.comoAyudarte} || Área de interés: ${data.areaInteres} || Mensaje: ${data.mensaje}`;
        console.log('Data: ', infoContact);
        sendEmail(infoContact);
        navigate('/gracias');
    }

    const sendEmail = (data) => {
        emailjs.send('service_7a5yigd', 'template_6ioe2lp', {
            from_name: 'Tech Mode',
            to_name: 'Fernando',
            message: data,
        }, 'v6P8tfP-jB949y3B-')
            .then((response) => {
                console.log('Email sent successfully:', response);
            })
            .catch((error) => {
                console.error('Error sending email:', error);
            });
    }

    return (
        <div className='contact__body'>
            <h1 className='contact__title text-center mb-0'>Contáctanos</h1>
            <div className='contact__repository px-3 px-sm-4 py-4 mt-sm-5'>
                <form className='contact__form' onSubmit={handleSubmit(onSubmit)}>
                    <div className='contact__form__box form-row row'>
                        <div className='contact__form__group form-group col-md-6 mb-3'>
                            <label className='contact__form__label mb-2' htmlFor='comoAyudarte'>¿Cómo podemos ayudarte?</label>
                            <select
                                className='form-control custom-select custom-select-lg'
                                id='comoAyudarte'
                                name='comoAyudarte'
                                {...register('comoAyudarte')}
                            >
                                <option value='consulta'>Consulta</option>
                                <option value='cotizacion'>Cotización</option>
                                <option value='soporte'>Soporte</option>
                            </select>
                        </div>
                        <div className='contact__form__group form-group col-md-6 mb-3'>
                            <label className='contact__form__label mb-2' htmlFor='areaInteres'>¿Cúal es el área de interés?</label>
                            <select className='form-control custom-select custom-select-lg' id='areaInteres' name='areaInteres' {...register('areaInteres')}>
                                <option value='desarrollo-movil'>Desarrollo Móvil</option>
                                <option value='desarrollo-web'>Desarrollo Web</option>
                                <option value='iot'>Internet de las Cosas</option>
                                <option value='cloud'>Cloud</option>
                                <option value='transformacion-digital'>Transformación Digital</option>
                                <option value='otros'>Otros</option>
                            </select>
                        </div>
                        <div className='contact__form__group mt-4 form-group col-md-12'>
                            <h3 className='contact__form__subtitle'>Información personal</h3>
                        </div>
                        <div className='contact__form__group form-group col-md-6 mb-3'>
                            <label className='contact__form__label mb-2' htmlFor='nombre'>Nombre*</label>
                            <input
                                className='form-control error-field'
                                id='nombre'
                                type='text'
                                name='Nombre'
                                placeholder='Escriba su nombre'
                                {
                                ...register('nombre', {
                                    required: true
                                })}
                            />
                            {
                                errors.nombre?.type === 'required' &&
                                <div className='mt-2 error_message text-danger message_Nombre'>
                                    <p className='mb-0'>
                                        Este campo es obligatorio
                                    </p>
                                </div>
                            }
                        </div>
                        <div className='contact__form__group form-group col-md-6 mb-3'>
                            <label className='contact__form__label mb-2' htmlFor='apellido'>Apellidos*</label>
                            <input
                                className='form-control error-field'
                                id='apellido'
                                type='text'
                                name='Apellido'
                                placeholder='Escriba sus apellidos'
                                {
                                ...register('apellido', {
                                    required: true
                                }
                                )}
                            />
                            {
                                errors.apellido?.type === 'required' && (
                                    <div className='mt-2 error_message text-danger message_Nombre'>
                                        <p className='mb-0'>
                                            Este campo es obligatorio
                                        </p>
                                    </div>
                                )
                            }
                        </div>
                        <div className='contact__form__group form-group col-md-6 mb-3'>
                            <label className='contact__form__label mb-2' htmlFor='telefono'>Teléfono*</label>
                            <input
                                className='form-control error-field'
                                id='telefono'
                                type='text'
                                name='Telefono'
                                placeholder='Escriba su número de teléfono'
                                {
                                ...register('telefono', {
                                    required: true,
                                    minLength: 9,
                                    maxLength: 9
                                })
                                }
                            />
                            {
                                (errors.telefono?.type === 'required' || errors.telefono?.type === 'minLength' || errors.telefono?.type === 'maxLength') && (
                                    <div className='mt-2 error_message text-danger message_Nombre'>
                                        <p className='mb-0'>
                                            Ingrese un número de teléfono válido
                                        </p>
                                    </div>
                                )
                            }
                        </div>
                        <div className='contact__form__group form-group col-md-6 mb-3'>
                            <label className='contact__form__label mb-2' htmlFor='email'>Correo electrónico*</label>
                            <input
                                className='form-control error-field'
                                id='email'
                                type='text'
                                name='Email'
                                placeholder='Escriba su correo electrónico'
                                {...register('email', {
                                    required: true,
                                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                })}
                            />
                            {
                                (errors.email?.type === 'pattern' || errors.email?.type === 'required') && (
                                    <div className='mt-2 error_message text-danger message_Nombre'>
                                        <p className='mb-0'>Ingrese un email válido</p>
                                    </div>
                                )
                            }

                        </div>

                        <div className='contact__form__group mt-4 form-group col-md-12'>
                            <h3 className='contact__form__subtitle'>Mensaje</h3>
                        </div>
                        <div className='contact__form__group form-group col-md-12'>
                            <textarea 
                                className='form-control bloque-texto' 
                                id='mensaje' 
                                name='Mensaje' 
                                placeholder='Escribe un mensaje...' 
                                rows='4'
                                {...register('mensaje')}
                            >
                            </textarea>
                        </div>
                        <button className='contact__form__btn mx-auto mt-5' type='submit'>Enviar solicitud</button>
                    </div>
                </form>
            </div >
        </div >
    );
}